/* istanbul ignore file */

import { FORM_FIELDS } from './form-fields';

export const FORM_PATHS = {
  EMAIL: () => FORM_FIELDS.EMAIL,
  AUTHORS: () => FORM_FIELDS.AUTHORS,
  SEARCHED_AUTHOR: () =>
    `${FORM_FIELDS.AUTHORS}.${FORM_FIELDS.SEARCHED_AUTHOR}`,
  SELECTED_AUTHORS: () =>
    `${FORM_FIELDS.AUTHORS}.${FORM_FIELDS.SELECTED_AUTHORS}`,
  WEBSITES: () => FORM_FIELDS.WEBSITES,
  WEBSITE: (innerField: string) => `${FORM_FIELDS.WEBSITES}.${innerField}`,
  LANGUAGE: () => FORM_FIELDS.LANGUAGE,
};
